import { z } from "zod";

export interface LegalOnboardingListItem {
  id: number;
  cuitCuil: string;
  tipoSociedad: string;
  estado: string
}

export interface LegalOnboardingListResponse {
  totalRecords: number;
  totalPages: number
  data: LegalOnboardingListItem[];
}

export interface GetLegalOnboardingRequestsFilters {
  cuitCuil?: string;
  tipoSociedad?: number[];
  estado?: number[];
  "P.Pagina"?: number;
  "P.Records"?: number;
}


export const legalOnboardingFilterSchema = z.object({
  cuitCuil: z.any().optional(),
  tipoSociedad: z.any().optional(),
  estado: z.any().optional(),
});
